<template>
  <div v-if="!videoWatched">
    <p class="mb-2">
      <strong>Watch the video then answer the questions</strong>
    </p>
    <video-player
      :item="videoItem"
      :active="true"
      :options="clientPlayerOptions"
      @currentTime="updateWatchedTime"
      @ended="setWatched"
    />
  </div>
</template>

<script>
import VideoPlayer from '@/views/lessons/lessonWidgets/videoWidget/VideoPlayer';

import throttle from 'lodash/throttle';
const VIDEO_KEY = 'intro-video';

export default {
  name: 'ActionPreScreenIntroVideo',
  components: {
    VideoPlayer,
  },
  props: {
    state: {},
    introVideoUrl: String,
    value: Boolean,
  },
  data() {
    return {
      clientPlayerOptions: {
        presentMode: false,
        autoPlay: false,
      },
      progress: 0,
    };
  },
  computed: {
    videoWatched: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    videoItem() {
      return {
        values: {
          url: this.introVideoUrl,
          summary: {},
          required: true,
          start: this.progress,
        },
      };
    },
    showIntroVideo() {
      return !!this.introVideoUrl;
    },
  },
  watch: {
    showIntroVideo(val, oldVal) {
      if (val === oldVal) return;
      this.checkIntroVideo();
    },
  },
  methods: {
    checkIntroVideo() {
      if (!this.showIntroVideo) {
        this.videoWatched = true;
        return;
      }

      const savedVideo = JSON.parse(localStorage.getItem(VIDEO_KEY)) || {};
      if (savedVideo?.url === this.introVideoUrl) {
        if (savedVideo.watched) return false;
        this.progress = savedVideo.progress || 0;
      }

      this.videoWatched = false;
    },

    updateWatchedTime: throttle(function (e) {
      this.saveVideoState({ progress: e.seconds });
    }, 3000),

    // save progress / already watched
    saveVideoState(updates) {
      const data = {
        url: this.state.videoUrl,
        ...updates,
      };

      localStorage.setItem(VIDEO_KEY, JSON.stringify(data));
    },

    async setWatched() {
      this.videoWatched = true;
      // await this.$nextTick();
      //this.saveVideoState({ watched: true });
    },
  },
  mounted() {
    this.checkIntroVideo();
  },
};
</script>
